/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

/**
 * 관리자 등급
 */
export type AdminGrade = (typeof AdminGrade)[keyof typeof AdminGrade];

export const AdminGrade = {
	MASTER: 'MASTER',
	AAA: 'AAA',
	BBB: 'BBB',
	CCC: 'CCC',
	GUEST: 'GUEST'
} as const;
